import React, { createContext, useContext, useEffect, useState } from 'react';
import { authStore } from '../stores/authStore';
import PermissionsService from '../services/permissions';

const PermissionContext = createContext({});

export const PermissionProvider = ({ children }) => {
  const { user } = authStore();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPermissions = async () => {
      if (user) {
        try {
          const userPermissions = await PermissionsService.getUserPermissions();
          const modules = PermissionsService.getAvailableModules(userPermissions);
          
          const permissionMap = {};
          modules.forEach(module => {
            permissionMap[module] = PermissionsService.getAvailableActions(userPermissions, module);
          });
          
          setPermissions(permissionMap);
        } catch (error) {
          console.error('Erro ao carregar permissões:', error);
        }
      }
      setLoading(false);
    };

    loadPermissions();
  }, [user]);

  const hasPermission = (module, action = 'view') => {
    return permissions[module]?.includes(action) || false;
  };

  const hasAnyPermission = (module) => {
    return permissions[module]?.length > 0 || false;
  };

  const hasAllPermissions = (module, actions) => {
    return actions.every(action => hasPermission(module, action));
  };

  const getModulePermissions = (module) => {
    return permissions[module] || [];
  };

  return (
    <PermissionContext.Provider
      value={{
        permissions,
        loading,
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        getModulePermissions
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissionContext = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissionContext deve ser usado dentro de PermissionProvider');
  }
  return context;
};